[
  {
    "maintenanceState": {
      "enabled": true
    },
    "timeStamp": 1686989604000
  },
  {
    "maintenanceState": {
      "enabled": false
    },
    "timeStamp": 1687076004000
  }
]
